import React, { memo, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './GameRankItem.module.less';
import { CONTEXT } from '../../../../config';
import ItemGame from './ItemGame';
import ItemGameActive from './ItemGameActive';
import { logging, logPostInfo } from '../../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ indexKey, rankInfo, logInfo, data }) => {
  const { pathname } = useLocation();
  const [logTag, setLogTag] = useState(
    pathname === `${CONTEXT}/game/gameRank` ? 'Game_Rank' : ' Game_Reco',
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeIndex, setActiveIndex] = useState(0);
  const logInfoData = useSelector(selectLogInfo);

  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.tag}_More`,
    source_app: `${logInfo.tag}`,
    source: `${logInfo.tag}`,
  };

  const backgroundIndex = index => {
    let i = index % 6;
    switch (i) {
      case 0:
        return styles.bg0;
        break;
      case 1:
        return styles.bg1;
        break;
      case 2:
        return styles.bg2;
        break;
      case 3:
        return styles.bg3;
        break;
      case 4:
        return styles.bg4;
        break;
      case 5:
        return styles.bg5;
        break;
    }
  };

  const handleMore = () => {
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_more,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${rankInfo.code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/rankmore_game?code=${rankInfo.code}`);
  };

  return (
    <div className={`${styles.item_rank} ${backgroundIndex(indexKey)}`}>
      <div className="item_rank_header">
        <div className="item_rank_title">
          {rankInfo?.nameBackgroundImg ? (
            <img src={rankInfo?.nameBackgroundImg} />
          ) : (
            <div className="desc">{rankInfo?.desc}</div>
          )}
        </div>
        <div className="more" onClick={() => handleMore()}>
          更多
        </div>
      </div>
      <div className="item_rank_content">
        {rankInfo?.apps.slice(0, 5).map((app, i) => (
          <div key={i} onMouseEnter={() => setActiveIndex(i)}>
            {i === activeIndex ? (
              <ItemGameActive
                soft={app}
                topIndex={i}
                logInfo={{
                  ...logInfo,
                  tag: logTag,
                  source: `${LOG_ACTION_SOURCE.source}||${rankInfo.code}`,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  // contentType: 'soft',
                  pageCardContentId: rankInfo.pageCardContentId,
                  rankCode: rankInfo.code,
                  org: rankInfo.org,
                  cardType: data?.cardType,
                  pageCardTitle: rankInfo.name,
                }}
              />
            ) : (
              <ItemGame
                soft={app}
                topIndex={i}
                logInfo={{
                  ...logInfo,
                  tag: logTag,
                  source: `${LOG_ACTION_SOURCE.source}||${rankInfo.code}`,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  // contentType: 'soft',
                  pageCardContentId: rankInfo.pageCardContentId,
                  rankCode: rankInfo.code,
                  org: rankInfo.org,
                  cardType: data?.cardType,
                  pageCardTitle: rankInfo.name,
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
});
